import { createContext, useContext } from 'react';
import type { Brand } from '@/lib/brand';

export interface BrandContextValue {
  brand: Brand;
  setBrand: (brand: Brand) => void;
  toggleBrand: () => void;
  canChooseBrand: boolean;
  isLoadingBrand: boolean;
  isPrimeTec: boolean;
  isEmpresarialPrime: boolean;
  isConecta: boolean;
}

export const BrandContext = createContext<BrandContextValue>({
  brand: 'empresarial-prime',
  setBrand: () => {},
  toggleBrand: () => {},
  canChooseBrand: false,
  isLoadingBrand: false,
  isPrimeTec: false,
  isEmpresarialPrime: true,
  isConecta: false,
});

export function useBrand() {
  return useContext(BrandContext);
}
